import { createTheme, MantineColorScheme, MantineThemeOverride } from '@mantine/core';
import {
	darkColors,
	errorColorScale,
	generateColorVariables,
	infoColorScale,
	lightColors,
	neutralColorScale,
	primaryColorScale,
	successColorScale,
	warningColorScale,
} from './colors';
import { componentConfig } from './componentConfig';

// Main theme configuration
export const baseTheme: MantineThemeOverride = createTheme({
	// Font configuration
	fontFamily: '"Albert Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
	fontFamilyMonospace: 'Monaco, Courier, monospace',
	headings: {
		fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
		fontWeight: '400',
	},

	// Color configuration
	primaryColor: 'primary',
	colors: {
		primary: primaryColorScale,
		neutral: neutralColorScale,
		info: infoColorScale,
		success: successColorScale,
		error: errorColorScale,
		warning: warningColorScale,
	},

	// Other configuration
	other: {
		// Add semantic colors for easy access
		lightColors,
		darkColors,
		// Add additional font families for specific use cases
		fonts: {
			body: '"Albert Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
			heading: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
			headingText:
				'"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
			mono: 'Monaco, Courier, monospace',
		},
	},
	...componentConfig.desktop,
});

// Helper function to apply theme CSS variables
export const applyThemeVariables = (colorScheme: MantineColorScheme) => {
	const root = document.documentElement;

	// Resolve 'auto' to actual scheme
	let resolvedScheme: 'light' | 'dark' = 'light';
	if (colorScheme === 'auto') {
		const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
		resolvedScheme = prefersDark ? 'dark' : 'light';
	} else {
		resolvedScheme = colorScheme;
	}

	// Apply color variables
	const colorVariables = generateColorVariables(resolvedScheme);
	Object.entries(colorVariables).forEach(([key, value]) => {
		root.style.setProperty(key, value);
	});

	// Set color scheme indicator
	root.setAttribute('data-mantine-color-scheme', colorScheme);
};
